// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__2K4tP","paymentContainer":"PaymentPage_paymentContainer__1o4QD"};